import React from 'react';
import { FaSpinner } from 'react-icons/fa';
import './LoadMoreButton.scss';

interface LoadMoreButtonProps {
  onClick: () => void;
  loading?: boolean;
  hasMore?: boolean;
}

const LoadMoreButton: React.FC<LoadMoreButtonProps> = ({ onClick, loading, hasMore }) => {
  if (!hasMore) {
    return (
      <div className="load-more-end">
        <span>You've reached the end</span>
      </div>
    );
  }

  return (
    <div className="load-more-container">
      <button
        className={`load-more-btn ${loading ? 'loading' : ''}`}
        onClick={onClick}
        disabled={loading}
        type="button"
      >
        {loading ? (
          <>
            <FaSpinner className="spinner" />
            <span>Loading...</span>
          </>
        ) : (
          <span>Load More</span>
        )}
      </button>
    </div>
  );
};

export default LoadMoreButton;
